export const TIPO_FACTURA_RECTIFICATIVA_ENUM = {
  SUSTITUTIVA: 1,
} as const

export type TipoFacturaRectificativa =
  (typeof TIPO_FACTURA_RECTIFICATIVA_ENUM)[keyof typeof TIPO_FACTURA_RECTIFICATIVA_ENUM]
